<form [formGroup]="form" >
  <div class="grid">
    <div class="col-12 md:col-8">
      <!-- <h3>Compare and Dedupe Donors</h3>-->
      <p-card>

        <div *ngFor="let field of fields" class="field compare-field-group">
          <div class="grid align-items-center">

            <div class="col-3">
              <label class="field-label">{{ field.label }}</label>
            </div>

            <div class="col-5">
              <div class="flex align-items-center justify-content-start mb-2">
                <p-radioButton *ngIf="field.options[0]"
                               [formControlName]="field.control"
                                [value]="field.options[0]"
                                class="mr-1"
                                (onClick)="setInputValue(field.control, field.options[0])"></p-radioButton>
                <label>{{ field.options[0] }}</label>
              </div>
              <div class="flex align-items-center justify-content-start">
                <p-radioButton *ngIf="field.options[1]"
                               [formControlName]="field.control"
                                [value]="field.options[1]"
                                class="mr-1"
                                (onClick)="setInputValue(field.control, field.options[1])"></p-radioButton>
                <label>{{ field.options[1] }}</label>
              </div>
            </div>

            <div class="col-4">
              <div class="flex align-items-center justify-content-start">
                <p-radioButton
                  [formControlName]="field.control"
                  class="mr-2"
                  [value]="'__custom__'">
                </p-radioButton>
                <input #inputRef
                       pInputText
                       [formControlName]="field.inputControl"
                       placeholder="Enter new"
                       (focus)="onCustomInputFocus(field)"
                       (input)="onCustomInputInput(field)" />
              </div>
            </div>
          </div>
        </div>

      </p-card>
    </div>

    <div class="col-12 md:col-4">
      <!-- <h3>Merged Donor Info</h3>-->

      <p-card styleClass="card-style-donor">

        <ng-template pTemplate="header">
          <p class="p-2">Merged Donor Info</p>
        </ng-template>
      
        <div class="p-2">
          <dl class="donor-dedupe">
            <dt>Donor ID</dt>
            <dd>
              {{ form.get('donorId')?.value === '__custom__' ? form.get('donorIdInput')?.value : form.get('donorId')?.value }}
            </dd>

            <dt>Name</dt>
            <dd>
              {{
                form.get('firstName')?.value === '__custom__' ? form.get('firstNameInput')?.value : form.get('firstName')?.value
              }}
              {{
                form.get('middleName')?.value === '__custom__' ? form.get('middleNameInput')?.value : form.get('middleName')?.value
              }}
              {{
                form.get('lastName')?.value === '__custom__' ? form.get('lastNameInput')?.value : form.get('lastName')?.value
              }}
              {{
                form.get('suffix')?.value === '__custom__' ? form.get('suffixInput')?.value : form.get('suffix')?.value
              }}
            </dd>

            <dt>Address</dt>
            <dd>
              {{ form.get('address1')?.value === '__custom__' ? form.get('addressInput1')?.value : form.get('address1')?.value }}
            </dd>
            <dd>
              {{ form.get('address2')?.value === '__custom__' ? form.get('addressInput2')?.value : form.get('address2')?.value }}
            </dd>
            <dd>
              {{ form.get('city')?.value === '__custom__' ? form.get('cityInput')?.value : form.get('city')?.value }}
            </dd>

            <dt>Contact Info</dt>
            <dd>
              Email: {{ form.get('email')?.value === '__custom__' ? form.get('emailInput')?.value : form.get('email')?.value }}
            </dd>
            <dd>
              Home Phone: {{ form.get('homePhone')?.value === '__custom__' ? form.get('homePhoneInput')?.value : form.get('homePhone')?.value }}
            </dd>
            <dd>
              Cell Phone: {{ form.get('cellPhone')?.value === '__custom__' ? form.get('cellPhoneInput')?.value : form.get('cellPhone')?.value }}
            </dd>

            <dt>Employment Info</dt>
            <dd>
              Employer: {{ form.get('employer')?.value === '__custom__' ? form.get('employerInput')?.value : form.get('employer')?.value }}
            </dd>
            <dd>
              Occupation: {{ form.get('occupation')?.value === '__custom__' ? form.get('occupationInput')?.value : form.get('occupation')?.value }}
            </dd>
            <dd>
              Office Phone: {{ form.get('officePhone')?.value === '__custom__' ? form.get('officePhoneInput')?.value : form.get('officePhone')?.value }}
            </dd>
          </dl>
        </div>
      </p-card>
    </div>
  </div>
</form>

<div class="mb-6 pb-4"></div>

<div class="imported-dialog-footer">
  <button pButton
          label="Cancel"
          class="p-button-text mr-2"
          (click)="onCancel()"></button>

  <button pButton
          label="Save"
          (click)="saveMergedDonor()"></button>
</div>
